
const getInitialState = () => {
	return [];
}
export default function resultsReducer(state = getInitialState(), action, fullState) {
	var newState;
	switch( action.type ){
		case 'results/load':
			// any initial processing can go here
			return [...state].map( r => {
				r['element'] = null;
				if ( r.type === 'on-page-element' ){
					var selector = r['on-page-element'] || false;
				} else if ( r.type === 'custom' ){
					var selector = r['id'] ? `#${ fullState.rootId }-custom-results .result-id-${ r['id'] }` : false;
				}
				if ( selector ){
					var element = document.querySelector( selector );
					if (element){
						// need jquery to copy all the event handlers...
						r['element'] = window.jQuery(element).clone(true)[0]
					}
					if ( r['element'] ){
						// in case of fauxTable
						window.jQuery(r['element']).children().css({
							height: '',
						}).children().css({
							height: ''
						});
						if ( r['element'].querySelector('.top-label') ){
							r['element'].querySelector('.top-label').innerHTML = "Recommended";
						}
					}
				}
				r['_selector'] = selector;
				return r;
			});
		default:
			return state;
	}
	return state;
}